/**
 * Utility functions for consistent tracking with GTM/GA4
 */

/**
 * Standardizes and sends a tracking event to GTM
 * Automatically adds clean page_path and other common parameters
 * 
 * @param {Object} vm - Vue component instance (this)
 * @param {Object} eventData - Event data to send
 */
export function trackEvent(vm, eventData) {
    if (!vm || !vm.$gtm) {
        return;
    }
    
    const route = vm.$route;
    if (!route) {
        return;
    }
    
    const bookId = route.params.bookId || 'unknown_book';
    
    let stepPath = 'unknown';
    const pathMatch = route.path.match(/\/step([1-3])/i);
    if (pathMatch && pathMatch[0]) {
        stepPath = pathMatch[0].substring(1);
    }
    
    const cleanPagePath = `/${bookId}/${stepPath}`;
    
    const standardizedData = {
        ...eventData,
        page_path: cleanPagePath,
        book_id: bookId,
        step: route.name || "unknown_step"
    };
    
    vm.$gtm.trackEvent(standardizedData);
}

/**
 * Get clean page path for the current route
 * 
 * @param {Object} route - Vue route object
 * @returns {String} Clean page path
 */
export function getCleanPagePath(route) {
    if (!route) return '/unknown/unknown';
    
    const bookId = route.params.bookId || 'unknown_book';
    
    let stepPath = 'unknown';
    const pathMatch = route.path.match(/\/step([1-3])/i);
    if (pathMatch && pathMatch[0]) {
        stepPath = pathMatch[0].substring(1);
    }
    
    return `/${bookId}/${stepPath}`;
}
